/* eslint-disable */
import { SignMessageArgs, SignTypedDataArgs } from '@wagmi/core'
import { useCallback } from 'react'
import { useAccount, useSignMessage as useSignMessageWagmi } from 'wagmi'
import { useSignTypedData as useSignTypedDataWagmi } from 'wagmi'

export function useSignMessage() {
  const { address, connector } = useAccount()
  const { signMessageAsync: sign } = useSignMessageWagmi()

  return {
    signMessageAsync: useCallback(
      async (args: SignMessageArgs) => {
        if (connector?.id === 'evm' && window.BinanceChain && address) {
          const res = await window.BinanceChain.eosSign?.(address, args.message as string)
          if (res) {
            return res.signature
          }
          return null
        }
        return sign(args)
      },
      [address, connector?.id, sign],
    ),
  }
}

export function useSignTypedData() {
  const { address, connector } = useAccount()
  const { signTypedDataAsync: sign } = useSignTypedDataWagmi()

  return {
    signTypedDataAsync: useCallback(
      async (args: any) => {
        // if (connector?.id === 'evm' && window.BinanceChain && address) {
        //   const res = await window.BinanceChain.eosSign?.(address, args.message as string)
        //   if (res) {
        //     return res.signature
        //   }
        //   return null
        // }
        return sign(args)
      },
      [address, connector?.id, sign],
    ),
  }
}
